import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const LusTypeApi = {
	getLusTypes() {
		const serviceUrl = prependRoot("/lustype", getApiRoot());
		return axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default LusTypeApi;
